import script from "./UpdateProject.vue?vue&type=script&lang=js"
export * from "./UpdateProject.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__